<style lang="stylus" scoped>
.back
    display:flex;
    align-items:center;
    font-size:18px;
    color:#686F84;
    cursor: pointer;
    width:85px;
    margin-bottom:20px;
    img
        margin-right:5px;
</style>

<template>
    <div class="back" @click="back" v-if="showBack">
        <img src="/static/img/left.png">
        <div>返回</div>
    </div>
</template>

<script>
export default {
    name: 'goBack',
    data() {
        return {
            showBack:true
        }
    },
    created(){
        if(window.history.length<=1){
            this.showBack = false;
        }else{
            this.showBack = true;
        }
    },
    methods: {
        back(){
             this.$router.go(-1);
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/goBack.vue